<template>
  <div class="w-full">
    <vs-table
      maxHeight="72vh"
      noDataText=""
      search
      pagination
      max-items="10"
      :data="portadores"
    >
      <template slot="header">
        <vs-row vs-w="12">
          <vs-col vs-w="6">
            <h4 style="color: #b4aa99">
              Portadores para uso financeiro. (Bancos)
            </h4>
          </vs-col>
          <vs-col vs-w="6">
            <ModalCadastroPortador @update="getPortadores" />
          </vs-col>
        </vs-row>
      </template>
      <template slot="thead">
        <vs-th sort-key="nome">Portador</vs-th>
        <vs-th>Ações</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr
          :state="data[indextr].lixeira == 1 ? 'danger' : ''"
          :key="indextr"
          v-for="(tr, indextr) in data"
        >
          <vs-td :data="data[indextr].nome">{{ data[indextr].nome }}</vs-td>

          <vs-td class="actions">
            <ModalEditarPortador
              :portador="data[indextr]"
              @update="getPortadores"
            />
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <div v-if="portadores.length == 0">
      <div class="con-colors">
        <ul>
          <li class="danger-box">
            <h2 class="p-5" style="color: white !important">
              Nenhum portador cadstrado
            </h2>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import ModalCadastroPortador from "./cadastro.vue"
import ModalEditarPortador from "./editar.vue"

export default {
  data () {
    return {
      portadores: []
    }
  },
  methods: {
    async getPortadores () {
      this.$vs.loading()
      try {
        this.portadores = await this.$http.get(`portador`)
      } catch (err) {
        const error = this.$httpErrors(err)
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        }
      } finally {
        this.$vs.loading.close()
      }
    }
  },
  components: {
    ModalCadastroPortador,
    ModalEditarPortador
  },
  mounted () {
    this.getPortadores()
  }
};
</script>

<style>
.actions {
  width: 60px !important;
}
</style>
